import React, { useCallback } from 'react'

import { hooks } from '@front/volcanion'

import _ from 'lodash'

import Callbacks from './callbacks'

const withContainer = Component => ({ event_id, order_id, ...props }) => {
  const { openNotification } = hooks.useNotification()

  const [createComment] = hooks.useModelFunction('comment', 'generate')
  const [handleEvent] = hooks.useModelFunction('event', 'handle')

  const approve = useCallback((extra) => handleEvent(_.merge({}, { event_id, action: 'approve' }, { extra })), [handleEvent, event_id])
  const approveRedispatch = useCallback(({ reason, cancelation_comment }) => approve({ reason, cancelation_comment }), [approve])
  const refuseIncident = useCallback((id, extra) => handleEvent({ event_id: id, action: 'refuse', extra }), [])

  const sendComment = useCallback(Callbacks.sendCommentHandler(openNotification, createComment, order_id), [openNotification, createComment, order_id])
  const confirmPairing = useCallback(Callbacks.confirmPairingHandler(openNotification, approve), [openNotification, approve])
  const refuse = useCallback(Callbacks.refuseHandler(openNotification, refuseIncident, event_id), [openNotification, refuseIncident, event_id])

  const mergedProps = {
    approve,
    approveRedispatch,
    sendComment,
    confirmPairing,
    refuse,
    order_id
  }

  return <Component {...mergedProps} {...props} />
}

export default withContainer
